import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import Landing from "pages/landing";
import PasswordReset from "pages/password-reset";
import SecureReset from "pages/secure-reset";
import DashboardOverview from './pages/dashboard-overview';
import DailyWellness from './pages/daily-wellness';
import HowItWorksPage from './pages/how-it-works';
import MaturationMonitor from './pages/maturation-monitor';
import AuthCallback from './pages/auth/AuthCallback';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/secure-reset" element={<SecureReset />} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Protected Routes */}
        <Route path="/dashboard-overview" element={
          <ProtectedRoute>
            <DashboardOverview />
          </ProtectedRoute>
        } />
        <Route path="/daily-wellness" element={
          <ProtectedRoute>
            <DailyWellness />
          </ProtectedRoute>
        } />
        <Route path="/how-it-works" element={
          <ProtectedRoute>
            <HowItWorksPage />
          </ProtectedRoute>
        } />
        <Route path="/maturation-monitor" element={
          <ProtectedRoute>
            <MaturationMonitor />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;